import type { Election } from "@/types/djangio"
import { useQuery } from "@tanstack/react-query"
import type { QueryFunctionContext } from "@tanstack/react-query"

const electionKeys = {
    all: [{ _model: "election" }] as const,
    detail: (jurisdictionKey: string) => [{ ...electionKeys.all[0], jurisdictionKey }] as const,
}

const fetchElections = async ({
    queryKey,
}: QueryFunctionContext<ReturnType<(typeof electionKeys)["detail"]>>): Promise<{ objects: Election[] }> => {
    const [{ jurisdictionKey }] = queryKey
    const regionId = DjangIO.app.ledger.types.ReportingJurisdictionType[jurisdictionKey].region
    const region = DjangIO.app.models.Region.by_value(regionId)
    const response = await (DjangIO as any).app.pac.models.election.Election.objects
        .filter({ region_name: region.region_name })
        .GET()

    return response
}

export const useElections = (jurisdictionKey: string) =>
    useQuery({
        queryKey: electionKeys.detail(jurisdictionKey),
        queryFn: fetchElections,
        enabled: Boolean(jurisdictionKey),
        select: (queryResultData) => {
            return queryResultData.objects
        },
    })
